(function(){
  function init(){
    var root=document.querySelector("[data-lgp-perso]");
    if(!root||root.dataset.lgpReady)return;
    var form=document.querySelector('form[action*="/cart/add"]');
    if(!form)return;
    root.dataset.lgpReady="1";
    form.setAttribute("enctype","multipart/form-data");
    var overlay=root.querySelector("[data-lgp-overlay]");
    var thumb=root.querySelector("[data-lgp-thumb]");
    var count=root.querySelector("[data-lgp-count]");
    var check=root.querySelector("[data-lgp-check]");
    var fonts={script:"\"Snell Roundhand\",\"Apple Chancery\",\"Segoe Script\",cursive",serif:"Georgia,\"Times New Roman\",serif",sans:"Inter,Helvetica,Arial,sans-serif"};
    function mirror(el){
      var name="properties["+el.getAttribute("data-lgp-field")+"]";
      var hid=form.querySelector('input[data-lgp-mirror="'+name+'"]');
      if(!hid){hid=document.createElement("input");hid.type="hidden";hid.name=name;hid.setAttribute("data-lgp-mirror",name);form.appendChild(hid);}
      hid.value=el.value||"";
      if(!el.value)hid.removeAttribute("name");else hid.name=name;
    }
    var txt=root.querySelector("#lgp-text");
    var fnt=root.querySelector("#lgp-font");
    function paint(){
      if(!overlay)return;
      var v=txt?txt.value.trim():"";
      if(count&&txt)count.textContent=String(txt.value.length);
      if(!v){overlay.hidden=true;overlay.textContent="";return;}
      overlay.hidden=false;
      overlay.textContent=v;
      overlay.style.fontFamily=fonts[fnt?fnt.value:"script"]||fonts.script;
      overlay.style.fontSize=(v.length>16?1.15:v.length>10?1.5:2)+"rem";
    }
    if(txt){txt.addEventListener("input",function(){paint();mirror(txt);});}
    if(fnt){fnt.addEventListener("change",function(){paint();mirror(fnt);});mirror(fnt);}
    var file=root.querySelector("[data-lgp-file]");
    if(file){
      file.name="properties[Image envoyee]";
      form.appendChild(file);
      file.style.display="none";
      var proxy=document.createElement("button");
      proxy.type="button";proxy.className="lgp-perso__filebtn";proxy.textContent="Choisir une image";
      root.querySelector(".lgp-perso__fields").appendChild(proxy);
      proxy.addEventListener("click",function(){file.click();});
      file.addEventListener("change",function(){
        var f=file.files&&file.files[0];
        if(!f){if(thumb)thumb.hidden=true;if(check)check.hidden=true;return;}
        proxy.textContent=f.name.length>26?f.name.slice(0,24)+"...":f.name;
        var msgs=[],ok=true;
        if(f.size>8*1024*1024){ok=false;msgs.push("Fichier trop lourd (max 8 Mo).");}
        var url=URL.createObjectURL(f);
        var im=new Image();
        im.onload=function(){
          if(im.naturalWidth<800||im.naturalHeight<800){ok=false;msgs.push("Image un peu petite ("+im.naturalWidth+" x "+im.naturalHeight+" px). En dessous de 800 px le rendu sera flou.");}
          else msgs.push("Definition correcte ("+im.naturalWidth+" x "+im.naturalHeight+" px).");
          var r=im.naturalWidth/im.naturalHeight;
          if(r<0.7||r>1.4)msgs.push("Format tres allonge : l\u2019image sera recadree au carre.");
          if(thumb){thumb.hidden=false;thumb.style.backgroundImage="url("+url+")";}
          if(check){check.hidden=false;check.className="lgp-perso__check "+(ok?"is-ok":"is-warn");check.textContent=(ok?"\u2713 ":"\u26a0 ")+msgs.join(" ");}
        };
        im.onerror=function(){if(check){check.hidden=false;check.className="lgp-perso__check is-warn";check.textContent="\u26a0 Fichier illisible. Essayez un PNG ou un JPG.";}};
        im.src=url;
      });
    }
    paint();
  }
  document.addEventListener("DOMContentLoaded",init);
  setTimeout(init,600);setTimeout(init,1800);
})();